import React, {useContext} from 'react';
import UserContext from '../components/common/UserContext.js';

// css
import '../assets/css/Help.css';

// reactstrap
import {Col, Row} from 'reactstrap';

// components
import PageHeader from '../components/common/PageHeader.js';
import HelpMenu from '../components/Help/HelpMenu.js';
import {toHtml} from '../components/common/utilities.js';


import licenseViewSummary from '../assets/img/Help/ksm-fsa-license-view-summary.png';
import licenseViewSummary2 from '../assets/img/Help/ksm-fsa-license-view-summary-2.png';
import licenseViewNoDownload from '../assets/img/Help/ksm-fsa-license-view-no-download-email.png';
import assignMore from '../assets/img/Help/ksm-fsa-license-view-assign-more.png';
import donut1 from '../assets/img/Help/ksm-fsa-license-view-donut-1.png';
import donut2 from '../assets/img/Help/ksm-fsa-license-view-donut-2.png';
import donut3 from '../assets/img/Help/ksm-fsa-license-view-donut-3.png';
import donut4 from '../assets/img/Help/ksm-fsa-license-view-donut-4.png';
import donut5 from '../assets/img/Help/ksm-fsa-license-view-donut-5.png';


// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {Text} from '../components/common/MultilingualText.js';
import {
    frequentlyAskedQuestionsKey,
    hostsKey,
    licensesKey,
    mainMessages,
    shortcutProductSelectionKey,
    budgetStatusKey,
    fsaAccessKey,
    flexibleSpendingAccountsKey,
    helpFSALicenseViewSectionKey,
    helpFSALicenseViewShortcutSectionKey,
    fsaLicenseViewKey,
    helpFSALicenseViewBudgetSectionKey,
    helpFSASummaryQAKey,
    helpFSASummaryLicensesQAKey,
    helpFSASummaryHostsQAKey,
    helpFSASummaryAccessQAKey
} from '../assets/text/MultilingualText.js';

function FSADetailedViewHelp(props) {
    const {siteLanguageDefault} = useContext(UserContext);
    const localization = useLocalization();

    function OrderedListItem({item}) {
        let children = null;

        if (item.substeps && item.substeps.length) {
            let types = item.substeps.map(i => i.type);
            let isDashed = types.every(t => t === "dash");

            children = isDashed ? <>
                {item.substeps.map(i => (
                    <OrderedListItem item={i} key={i.order}/>
                ))}
            </> : <ol>
                {item.substeps.map(i => (
                    <OrderedListItem item={i} key={i.order}/>
                ))}
            </ol>;
        }

        if (item.type === "dash") {
            return (
                <div
                    style={{
                        ...bulletStyle,
                        ...{display: 'flex'}
                    }}
                >
                    &ndash;&nbsp;{toHtml(item.step)}
                </div>
            )
        } else {
            return (
                <li>
                    <div style={children ? {paddingBottom: 6} : {}}>
                        {toHtml(item.step)}
                    </div>
                    {children}
                </li>
            );
        }
    }

    const bulletStyle = {
        paddingTop: 6,
        paddingBottom: 6
    };

    const borderStyle = {
        border: "1px solid",
        borderCollapse: "collapse",
        verticalAlign: 'top'
    }

    const helpContent = {
        'header': {
            key: fsaLicenseViewKey,
            default: mainMessages[siteLanguageDefault][fsaLicenseViewKey]
        },
        'topics': [
            {
                key: fsaLicenseViewKey,
                default: mainMessages[siteLanguageDefault][fsaLicenseViewKey],
                hash: '#license-view'
            },
            {
                key: shortcutProductSelectionKey,
                default: mainMessages[siteLanguageDefault][shortcutProductSelectionKey],
                hash: '#shortcut'
            },
            {
                key: budgetStatusKey,
                default: mainMessages[siteLanguageDefault][budgetStatusKey],
                hash: '#budget-status'
            }
        ],
        'faq': [
            {
                key: flexibleSpendingAccountsKey,
                default: mainMessages[siteLanguageDefault][flexibleSpendingAccountsKey],
                hash: '#flexible-spending-accounts-faq'
            },
            {
                key: licensesKey,
                default: mainMessages[siteLanguageDefault][licensesKey],
                hash: '#licenses-faq'
            },
            {
                key: hostsKey,
                default: mainMessages[siteLanguageDefault][hostsKey],
                hash: '#hosts-faq'
            },
            {
                key: fsaAccessKey,
                default: mainMessages[siteLanguageDefault][fsaAccessKey],
                hash: '#access-faq'
            }
        ]
    };

    const licenseViewContent = localization.toLanguageString(
        helpFSALicenseViewSectionKey,
        mainMessages[siteLanguageDefault][helpFSALicenseViewSectionKey]
    );

    const shortcutContent = localization.toLanguageString(
        helpFSALicenseViewShortcutSectionKey,
        mainMessages[siteLanguageDefault][helpFSALicenseViewShortcutSectionKey]
    );

    const budgetContent = localization.toLanguageString(
        helpFSALicenseViewBudgetSectionKey,
        mainMessages[siteLanguageDefault][helpFSALicenseViewBudgetSectionKey]
    );

    const fsaSummaryQA = localization.toLanguageString(
        helpFSASummaryQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryQAKey]
    );

    const licensesQA = localization.toLanguageString(
        helpFSASummaryLicensesQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryLicensesQAKey]
    );

    const hostsQA = localization.toLanguageString(
        helpFSASummaryHostsQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryHostsQAKey]
    );

    const accessQA = localization.toLanguageString(
        helpFSASummaryAccessQAKey,
        mainMessages[siteLanguageDefault][helpFSASummaryAccessQAKey]
    );

    return (
        <>
            <PageHeader/>
            <div className={"ksm-page-container"}>
                <Row>
                    <Col xs="3">
                        <HelpMenu helpContent={helpContent}/>
                    </Col>
                    <Col xs="9">
                        <div
                            className={"k-h3 header"}
                            id="license-view"
                        >
                            <Text
                                textkey={fsaLicenseViewKey}
                                textdefault={mainMessages[siteLanguageDefault][fsaLicenseViewKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            {toHtml(licenseViewContent.section_one)}
                            <ol type="a">
                                {licenseViewContent.section_one_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                                <img style={{width:'85%'}} src={licenseViewSummary} alt={"ksm-fsa-license-view-summary"}/>
                            </ol>
                            <p>
                                {licenseViewContent.section_four}
                            </p>
                            {licenseViewContent.section_four_bullets ? <ul>
                                {licenseViewContent.section_four_bullets.map((bullet, index) => <li
                                    key={'ea-detailed-view-license-view-bullet-' + index}>
                                    {toHtml(bullet)}
                                </li>)}
                            </ul> : <></>}
                            <p>
                                {licenseViewContent.section_five}
                            </p>
                            <ol type="a">
                                {licenseViewContent.section_five_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                            </ol>
                            <p>
                                {licenseViewContent.section_six}
                            </p>
                            <ol type="a" start={4}>
                                {licenseViewContent.section_six_steps.map(step =>
                                    <OrderedListItem item={step} key={step.order}/>
                                )}
                            </ol>
                            <img style={{width:'85%'}} src={licenseViewSummary2} alt="ksm-fsa-license-view-summary-2"/>
                            <p>
                                {licenseViewContent.section_seven}
                            </p>
                            <img style={{width:'85%'}} src={licenseViewNoDownload} alt="ksm-fsa-license-product-view"/>
                        </div>
                        <div
                            className={"k-h3"}
                            id="shortcut"
                        >
                            <Text
                                textkey={shortcutProductSelectionKey}
                                textdefault={mainMessages[siteLanguageDefault][shortcutProductSelectionKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            {toHtml(shortcutContent.section_one)}

                            <img style={{width:'85%'}} src={assignMore} alt="ksm-fsa-license-assign-more"/>
                        </div>
                        <div
                            className={"k-h3 header"}
                            id="budget-status"
                        >
                            <Text
                                textkey={budgetStatusKey}
                                textdefault={mainMessages[siteLanguageDefault][budgetStatusKey]}
                            />
                        </div>
                        <hr/>
                        <div className="section">
                            {toHtml(budgetContent.section_one)}
                            {budgetContent.section_one_bullets ? <ul>
                                {budgetContent.section_one_bullets.map((bullet, index) => <li
                                    key={'ea-detailed-view-subscription-pool-bullet-' + index}>
                                    {toHtml(bullet)}
                                </li>)}
                            </ul> : <></>}
                            {toHtml(budgetContent.section_two)}
                            <br/>
                            <table style={borderStyle}>
                                <tbody>
                                <tr style={borderStyle}>
                                    <th style={borderStyle}></th>
                                    <th style={borderStyle}>{toHtml(budgetContent.section_two_table_1_2)}</th>
                                </tr>
                                <tr style={borderStyle}>
                                    <td style={borderStyle}>
                                        <div style={{padding: 8}}>
                                            {toHtml(budgetContent.section_two_table_2_1)}
                                        </div>
                                    </td>
                                    <td style={borderStyle}>
                                        <img
                                            style={{width:'100%'}}
                                            src={donut1}
                                             alt={"ksm-fsa-license-view-all-budget"}/>
                                    </td>
                                </tr>
                                <tr style={borderStyle}>
                                    <td style={borderStyle}>
                                        <div style={{padding: 8}}>
                                            {toHtml(budgetContent.section_two_table_3_1)}
                                        </div>
                                    </td>
                                    <td style={borderStyle}>
                                        <img src={donut2}
                                             style={{width:'100%'}}
                                             alt={"ksm-fsa-license-view-cart-budget"}/>
                                    </td>
                                </tr>
                                <tr style={borderStyle}>
                                    <td style={borderStyle}>
                                        <div style={{padding: 8}}>
                                            {toHtml(budgetContent.section_two_table_4_1)}
                                        </div>
                                    </td>
                                    <td style={borderStyle}>
                                        <img src={donut3}
                                             style={{width:'100%'}}
                                             alt={"ksm-fsa-license-view-consumed-cart"}/>
                                    </td>
                                </tr>

                                <tr style={borderStyle}>
                                    <td style={borderStyle}>
                                        <div style={{padding: 8}}>
                                            {toHtml(budgetContent.section_two_table_5_1)}
                                        </div>
                                    </td>
                                    <td style={borderStyle}>
                                        <img src={donut4}
                                             style={{width:'98%'}}
                                             alt={"ksm-fsa-license-view-full-budget"}/>

                                        <br/>
                                        <br/>
                                        <img src={donut5}
                                             style={{width:'99%'}}
                                             alt={"ksm-fsa-license-view-overdraft"}/>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className={"k-h3 header"}>
                            <Text
                                textkey={frequentlyAskedQuestionsKey}
                                textdefault={mainMessages[siteLanguageDefault][frequentlyAskedQuestionsKey]}
                            />
                        </div>
                        <hr/>
                        <div id="flexible-spending-accounts-faq">
                            <h3>
                                <Text
                                    textkey={flexibleSpendingAccountsKey}
                                    textdefault={mainMessages[siteLanguageDefault][flexibleSpendingAccountsKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {fsaSummaryQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"fsa-summary-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="licenses-faq">
                            <h3>
                                <Text
                                    textkey={licensesKey}
                                    textdefault={mainMessages[siteLanguageDefault][licensesKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {licensesQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"licenses-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="hosts-faq">
                            <h3>
                                <Text
                                    textkey={hostsKey}
                                    textdefault={mainMessages[siteLanguageDefault][hostsKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {hostsQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"hosts-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                })}
                            </ul>
                        </div>
                        <div id="access-faq">
                            <h3>
                                <Text
                                    textkey={fsaAccessKey}
                                    textdefault={mainMessages[siteLanguageDefault][fsaAccessKey]}
                                />
                            </h3>
                            <ul className="indent">
                                {accessQA ? accessQA.map((questionAnswer, index) => {
                                    return (
                                        <div key={"ea-access-qa-" + index}>
                                            <li>
                                                {toHtml(questionAnswer.Q)}
                                                <br/>
                                                <div className="indent">
                                                    {toHtml(questionAnswer.A)}
                                                    <br/>
                                                </div>
                                            </li>
                                        </div>
                                    )
                                }) : <></>}
                            </ul>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    );
}

export default FSADetailedViewHelp;

